import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOfferColumns } from '../../../hooks/useColumns';
import MaterialTable from '../../MaterialTable';
import { Badge, IconButton } from '@mui/material';
import { AuctionIcon } from '../../atoms/Icons';
import { useNavigate } from 'react-router-dom';
var OrderedOffersTable = function (_a) {
    var offerList = _a.offerList;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var OfferColumns = useOfferColumns('admin');
    var renderAuctionIcon = React.useCallback(function (offer) {
        return offer.orderType !== 'auction' ? ('') : (React.createElement(IconButton, { onClick: function () {
                return navigate("/admin/offer_lists/".concat(offerList.id, "/auctions/").concat(offer.id));
            } },
            React.createElement(Badge, { color: "primary", badgeContent: offer.bidsRoasterCount, max: 999 },
                React.createElement(AuctionIcon, { "aria-label": "auction" }))));
    }, [navigate, offerList.id]);
    var columns = React.useMemo(function () { return [
        OfferColumns.lotNumber,
        {
            title: ' ',
            render: renderAuctionIcon,
            align: 'center',
            width: '10%',
            sorting: false,
            filtering: false,
        },
        OfferColumns.ordersCount,
        OfferColumns.ordersTotalQuantity,
        OfferColumns.ordersTotalWeight,
        OfferColumns.typicaStockTotalQuantity,
        OfferColumns.typicaStockTotalWeight,
    ]; }, [OfferColumns, renderAuctionIcon]);
    return (React.createElement(MaterialTable, { title: t('offers'), model: "offer", columns: columns, data: offerList.offers }));
};
export default OrderedOffersTable;
